<template>
  <div class="abouts">
    <nav-headers />
    <div class="contents">
      <div class="in-banner">
        <div class="p-nav">
          <div class="p-title">
            <div class="p-1">ABOUT</div>
            <div class="p-2">Home / ABOUT</div>
          </div>
        </div>
        <img src="../assets/img/ny-04-ABOUT.jpg" width="100%" height="auto" />
      </div>
      <div class="pageBox waps ">
        <div class="products-nav-centerss">
          <div class="products-leixing">
            <el-select v-model="newType" placeholder="ALL" @change="change()">
              <el-option v-for="item in soptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            </div>
        </div>

        <div class="products-nav-centers">
          <div class="products-leixing">
            <span style="margin-right: 20px;" :class="{ 'active': newType == 1 }" @click="changeNew(1)"> Company Profile
            </span>
            /
            <span style="margin-left: 20px;margin-right: 20px;" :class="{ 'active': newType == 2 }"
              @click="changeNew(2)"> Our Company
            </span>
            /
            <span style="margin-left: 20px;margin-right: 20px" :class="{ 'active': newType == 3 }"
              @click="changeNew(3)"> Our Product
            </span>
            /
            <span style="margin-left: 20px;margin-right: 20px" :class="{ 'active': newType == 4 }"
              @click="changeNew(4)"> Product
              Application </span>
            /
            <span style="margin-left: 20px;margin-right: 20px" :class="{ 'active': newType == 5 }"
              @click="changeNew(5)"> Our Certificate
            </span>
            /
            <span style="margin-left: 20px;margin-right: 20px" :class="{ 'active': newType == 6 }"
              @click="changeNew(6)"> Production
              Market </span>
            /
            <span style="margin-left: 20px;" :class="{ 'active': newType == 7 }" @click="changeNew(7)"> Our Service
            </span>
          </div>
        </div>
        <div class="web_content" v-show="newType == 0">
          <div class="about-items animate-box">
            <div class="left animate" data-ani="bounceInLeft">
              <div class="about-title">ABOUT US</div>
              <div class="fonts">ZHEJIANG YINGCHENG</div>
              <div class="fonts">INTERNATIONAL TRADE</div>
              <div class="fonts">CO., LTD.</div>
              <div class="text">
                <div>We have more than 20 years of production and sales experience, focusing on</div>
                <div>the manufacture of professional quality tools and hardware products,</div>
                <div>including pumps, cleaning machines, power tools, hand tools and more. From</div>
                <div>product design, Production, Packaging to inspection, every step is strictly</div>
                <div>checked, Besides, Our products have passed the main international...</div>
              </div>
              <div class="slide-mores" @click="changeNew('1')">
                <div class="slide-more ">View More</div>
              </div>
            </div>

            <div class="right animate" data-ani="bounceInRight">
              <video-player class="video-player-box" ref="videoPlayer" :playsinline="true" :options="playerOptions">
              </video-player>
            </div>

            <div class="lefts animate" data-ani="bounceInLeft">
              <div class="about-title">ABOUT US</div>
              <div class="fonts">ZHEJIANG YINGCHENG</div>
              <div class="fonts">INTERNATIONAL TRADE</div>
              <div class="fonts">CO., LTD.</div>
              <div class="text">
                <div>We have more than 20 years of production and sales experience, focusing on
                  the manufacture of professional quality tools and hardware products,
                  including pumps, cleaning machines, power tools, hand tools and more. From
                  product design, Production, Packaging to inspection, every step is strictly
                  checked, Besides, Our products have passed the main international...</div>
              </div>
              
              <div class="slide-mores" @click="changeNew('1')">
                <div class="slide-more ">View More</div>
              </div>
            </div>
          </div>
          <div class="about-company" @mouseover="start">
            <div class="about-s animate-box" :style="{ 'width': width + 'px', 'marginLeft': left + 'px' }">
              <div class="items animate" data-ani="bounceInLeft">
                <div class="p-s">
                  <div class="f-1" style="font-size:40px;">
                    <countTo ref='example1' :startVal="0" :endVal="20" :duration="2000"></countTo>
                    +
                  </div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;margin-top: 25px;">Production</div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;">experience</div>
                </div>
                <img src="../assets/img/gd-01.jpg" width="100%" height="auto"></img>
              </div>
              <div class="items animate" data-ani="bounceInRight">
                <div class="p-ss">
                  <div class="f-1" style="font-size:40px;">
                    <countTo ref='example2' :startVal="0" :endVal="300" :duration="2000"></countTo>
                    +
                  </div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;margin-top: 25px;">More than 300</div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;">models</div>
                </div>
                <img src="../assets/img/gd-02.jpg" width="100%" height="auto"></img>
              </div>
              <div class="items animate" data-ani="bounceInLeft">
                <div class="p-s">
                  <div class="f-1" style="font-size:40px;">
                    <countTo ref='example3' :startVal="0" :endVal="150" :duration="2000"></countTo>
                    +
                  </div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;margin-top: 25px;">Sold in multiple</div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;">countries</div>
                </div>
                <img src="../assets/img/gd-03.jpg" width="100%" height="auto"></img>
              </div>
              <div class="items animate" data-ani="bounceInRight">
                <div class="p-ss">
                  <div class="f-1" style="font-size:40px;">
                    <countTo ref='example4' :startVal="0" :endVal="97" :duration="2000"></countTo>
                    %
                  </div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;margin-top: 25px;">Customer</div>
                  <div class="f-2" style="font-size: 18px;line-height: 20px;">satisfaction</div>
                </div>
                <img src="../assets/img/gd-04.jpg" width="100%" height="auto"></img>
              </div>
              <div class="itemss animate" data-ani="bounceInRight" :style="{ 'width': widths + 'px' }">
                <div class="items-box">
                  <div class="title">OUR COMPANY</div>
                  <div class="text">FOR CUSTOMER TO SUCCEED IN THE LOCAL MARKET</div>
                  <div class="font">Strive to make every batch of goods perfect and high quality. At the same time, we
                    have established a good relationship of mutual trust with
                    customers all over the world, and also for customers to succeed in the local market.</div>
                  
                  <div class="slide-mores" @click="changeNew('2')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="about-companys" @touchmove="starts" >
            <div class="about-s animate-box">
              <div style="width: 90%;margin:0px auto;overflow:hidden" >
                <div class="items animate" data-ani="bounceInLeft">
                  <div class="p-s">
                    <div class="f-1" style="font-size:30px;">
                      <countTo ref='example5' :startVal="0" :endVal="20" :duration="2000"></countTo>
                      +
                    </div>
                    <div class="f-2" style="font-size: 15px;line-height: 20px;margin-top: 25px; ">Production</div>
                    <div class="f-2" style="font-size: 15px;line-height: 20px;">experience</div>
                  </div>
                  <img src="../assets/img/gd-01.jpg" width="100%" height="auto"></img>
                </div>
                <div class="items animate" data-ani="bounceInRight">
                  <div class="p-ss">
                    <div class="f-1" style="font-size:24px;">
                      <countTo ref='example6' :startVal="0" :endVal="300" :duration="2000"></countTo>
                      +
                    </div>
                    <div class="f-2" style="line-height: 20px;margin-top: 25px;">More than 300 models</div>
                  </div>
                  <img src="../assets/img/gd-02.jpg" width="100%" height="auto"></img>
                </div>
                <div class="items animate" data-ani="bounceInLeft">
                  <div class="p-s">
                    <div class="f-1" style="font-size:24px;">
                      <countTo ref='example7' :startVal="0" :endVal="150" :duration="2000"></countTo>
                      +
                    </div>
                    <div class="f-2" style="line-height: 20px;margin-top: 25px;">Sold in multiple countries</div>
                  </div>
                  <img src="../assets/img/gd-03.jpg" width="100%" height="auto"></img>
                </div>
                <div class="items animate" data-ani="bounceInRight">
                  <div class="p-ss">
                    <div class="f-1" style="font-size:24px;">
                      <countTo ref='example8' :startVal="0" :endVal="97" :duration="2000"></countTo>
                      %
                    </div>
                    <div class="f-2" style="line-height: 20px;margin-top: 25px;">Customer satisfaction</div>
                  </div>
                  <img src="../assets/img/gd-04.jpg" width="100%" height="auto"></img>
                </div>
              </div>
              <div class="itemss animate" data-ani="bounceInRight">
                <div class="items-box">
                  <div class="title">OUR COMPANY</div>
                  <div class="text">FOR CUSTOMER TO SUCCEED</div>
                  <div class="text" style="margin-top: 0px;">IN THE LOCAL MARKET</div>
                  <div class="font">Strive to make every batch of goods perfect and high quality. At the same time, we
                    have </div>
                  <div class="font" style="margin-top: 0px;">established a good relationship of mutual trust with
                    customers all over the world, and also for </div>
                  <div class="font" style="margin-top: 0px;">customers to succeed in the local market.</div>
                  
                  <div class="slide-mores" @click="changeNew('2')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="about-i">
            <div class="about-pro">
              <div class="le">
                <img src="../assets/img/gd-05.jpg" style="width: 100%;height: auto;"></img>
              </div>
              <div class="about-products">
                <div class="f-1">OUR PRODUCT</div>
                <div class="t-1" style="margin-top: 25px;">FOCUS ON TOOLS AND </div>
                <div class="t-1">HANDWARE PRODUCTS</div>
                <div class="font-centers">
                  <div class="f-2">
                    <span class="f-p"></span>We have more than 20 years of production and sales experience.
                  </div>
                  <div class="f-2" style="margin-top: 20px;">
                    <span class="f-p"></span>From product design, Production, Packaging to inspection, every step is
                    strictly checked.
                  </div>
                  <div class="f-2" style="margin-top: 20px;">
                    <span class="f-p"></span>Our products have passed the main international safety certification.
                  </div>
                  <div class="f-2" style="margin-top: 20px;">
                    <span class="f-p"></span>Strictly comply with the ISO9002 quality control system certification.
                  </div>
                </div>
                <div class="slide-mores"  @click="changeNew('3')">
                  <div class="slide-more ">View More</div>
                </div>
              </div>
            </div>
          </div>


          <div class="about-is">
            <div class="about-pro">
              <div class="le">
                <img src="../assets/img/gd-05.jpg" style="width: 100%;height: auto;"></img>
              </div>
              <div class="about-products">
                <div class="f-1">OUR PRODUCT</div>
                <div class="t-1">FOCUS ON TOOLS AND </div>
                <div class="t-1">HANDWARE PRODUCTS</div>
                <div class="font-centers">
                  <div class="f-2">
                    <span class="f-p"></span>We have more than 20 years of production and sales experience.
                  </div>
                  <div class="f-2" style="margin-top: 25px;">
                    <span class="f-p"></span>From product design, Production, Packaging to inspection, every step is
                    strictly checked.
                  </div>
                  <div class="f-2" style="margin-top: 25px;">
                    <span class="f-p"></span>Our products have passed the main international safety certification.
                  </div>
                  <div class="f-2" style="margin-top: 25px;">
                    <span class="f-p"></span>Strictly comply with the ISO9002 quality control system certification.
                  </div>
                </div>
                <div class="slide-mores"  @click="changeNew('3')">
                  <div class="slide-more ">View More</div>
                </div>
              </div>
             
            </div>
          </div>

          <div class="about-ps">
            <div class="about-f">
              <div class="about_text">
                <div class="t1">PRODUCTION CENTER</div>
                <div class="t2">CUSTOMER SATISFACTION</div>
                <div class="t2" style="margin-top: 0px;">IS OVER 97%</div>
                <div class="slide-mores"  @click="changeNew('3')">
                  <div class="slide-more ">View More</div>
                </div>
              </div>
              <img src="../assets/img/f-1.png" style="width: 100%;height: auto;"></img>
            </div>
          </div>
          <div class="mobile-cs">
            <div class="mobile-p-t">
              <div class="p-o">
                <div class="p-s">
                  <div class="p-titles">PRODUCTION CENTER</div>
                  <div class="p-text " style="margin-top: 25px;">CUSTOMER SATISFACTION</div>
                  <div class="p-text ">IS OVER 97%</div>
                  <div class="slide-mores"  @click="changeNew('3')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-cs">
            <div class="product-is">
              <div class="t1">PRODUCT APPLICATION</div>
              <div class="ts">
                <div class="items" style="margin-left: 0%;">
                  <div class="p-t">Industrial solutions</div>
                  <img src="../assets/img/gd-06.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Building solutions</div>
                  <img src="../assets/img/gd-07.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Gardening Solutions</div>
                  <img src="../assets/img/gd-08.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Special process solutions</div>
                  <img src="../assets/img/gd-09.jpg" style="width: 100%;height: auto;"></img>
                </div>
              </div>
              <div class="slide-mores" @click="changeNew('4')">
                <div class="slide-more ">View More</div>
              </div>
            </div>
          </div>
          <div class="product-css">
            <div class="product-is">
              <div class="t1">PRODUCT APPLICATION</div>
              <div class="ts">
                <div class="items" style="margin-left: 0%;">
                  <div class="p-t">Industrial solutions</div>
                  <img src="../assets/img/gd-06.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Building solutions</div>
                  <img src="../assets/img/gd-07.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Gardening Solutions</div>
                  <img src="../assets/img/gd-08.jpg" style="width: 100%;height: auto;"></img>
                </div>
                <div class="items">
                  <div class="p-t">Special process solutions</div>
                  <img src="../assets/img/gd-09.jpg" style="width: 100%;height: auto;"></img>
                </div>
              </div>
              <div class="slide-mores" @click="changeNew('4')">
                <div class="slide-more ">View More</div>
              </div>
            </div>
          </div>
          <div class="cer-abouts">
            <div class="cer-title">OUR CERTIFICATE</div>
            <div class="swiper-centers">
              <swiper class="swiper-container" :options="swiperOption">
                <swiper-slide v-for="(item, index) in slideList" :key="index" style="text-align: center">
                  <img :src="baseUrl+item.image" alt="" width="60%" height="auto" />
                </swiper-slide>
              </swiper>
            </div>
            <div class="slide-mores" @click="changeNew('5')">
              <div class="slide-more ">View More</div>
            </div>
          </div>
          <div class="service-abouts">
            <div class="service-s">
              <div class="le">
                <div class="text">
                  <div class="title">PRODUCTION MARKET</div>
                  <div class="slide-mores" @click="changeNew('6')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
                <img src="../assets/img/gd-10.jpg" width="100%" height="auto"></img>
              </div>
              <div class="ri">
                <div class="text">
                  <div class="title">OUR SERVICE</div>
                  <div class="slide-mores" @click="changeNew('7')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
                <img src="../assets/img/gd-11.jpg" width="100%" height="auto"></img>
              </div>
            </div>
          </div>
          <div class="service-about">
            <div class="service-s">
              <div class="le">
                <div class="text">
                  <div class="title">PRODUCTION MARKET</div>
                  <div class="slide-mores" @click="changeNew('6')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
                <img src="../assets/img/gd-10.jpg" width="100%" height="auto"></img>
              </div>
              <div class="ri">
                <div class="text">
                  <div class="title">OUR SERVICE</div>
                  <div class="slide-mores" @click="changeNew('7')">
                    <div class="slide-more ">View More</div>
                  </div>
                </div>
                <img src="../assets/img/gd-11.jpg" width="100%" height="auto"></img>
              </div>
            </div>
          </div>
        </div>
        <div class="web_content" v-show="newType == '1'">
          <div class="about-pros"v-html='Factorys.maincontent'></div>
        </div>
        <div class="web_content" v-show="newType == '2'">
          <div class="about-pros"v-html='Factoryss.maincontent'></div>
        </div>
        <div class="web_content" v-show="newType == '3'">
          <div class="about-pros" v-html='Factorysss.maincontent'></div>
        </div>
        <div class="web_content" v-show="newType == '4'">
          <div class="about-pros" v-html='Factoryssss.maincontent'></div>
        </div>
        <div class="web_content" v-show="newType == '5'">
          <certificate></certificate>
        </div>
        <div class="web_content" v-show="newType == '6'">
          <div class="about-pros"  v-html='Factoryssssss.maincontent'></div>
        </div>
        <div class="web_content" v-show="newType == '7'">
          <div class="about-pros" v-html='Factorysssssss.maincontent'></div>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
<script>

import countTo from 'vue-count-to';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//import NavHeaders from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import certificate from "@/pages/certificate.vue";
export default {
  name: 'contact',
  data() {
    return {
      newType: 1,
      soptions: [{
          value: '0',
          label: 'ALL'
        }, {
          value: '1',
          label: 'Company Profile'
        }, {
          value: '2',
          label: 'Company Profile'
        }, {
          value: '3',
          label: 'Our Company'
        },{
          value: '4',
          label: 'Product Application'
        },{
          value: '5',
          label: 'Our Certificate'
        },{
          value: '6',
          label: 'Production Market'
        },{
          value: '7',
          label: 'Our Service'
        },

      ],
      show: 1,
      left: '',
      width: '',
      widths: '',
      swiperOption: {
        effect: "coverflow",
        slidesPerView: 5,
        spaceBetween: 10,
        slidesPerGroup: 1,
        autoplay: false,
        loop: false,
        speed: 3000,
      },
      slideList: [
        {}, {}, {}, {}, {}
      ],
      playerOptions: {
        controls: true,
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: 'http://yingcheng.0576hs.com/uploads/media.mp4' // url地址
        }],
        poster: 'http://yingcheng.0576hs.com/uploads/cs_3.png', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      form: {
        name: '',
        email: '',
        description: '',
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],

      },
      id: this.$route.params.id,
      Factorys:'',
      Factoryss:'',
      Factorysss:'',
      Factoryssss:'',
      Factorysssss:'',
      Factoryssssss:'',
      Factorysssssss:'',
      Factoryssssssss:'',
      
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      total: 0,
      baseUrl:'http://yingcheng.0576hs.com',
      showSlide: '', //控制动画效果
      list: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      product: [

      ],

    };
  },
  components: {
    NavHeaders: () => import('@/components/NavHeaders.vue'),
    NavFooter,
    Swiper,
    SwiperSlide,
    certificate,
    countTo
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        console.log('Route changed from', from.path, 'to', to);
        let self = this
        this.newType = to.params.id
        self.id = self.newType
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })
  },

  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  created() {
    this.newType = this.$route.params.id
    let self=this
    self.init()
    self.inits()
    self.initss()
    self.initsss()
    //self.initssss()
    self.initsssss()
    self.initssssss()
    self.getProductList()
    document.documentElement.scrollTop = "0px";
    let viewportWidth = document.documentElement.clientWidth;
    if(viewportWidth < 1601){
      this.left = (parseInt(viewportWidth) - 1200) / 2
    }else{
      this.left = (parseInt(viewportWidth) - 1600) / 2
    }
    this.width = viewportWidth - this.left
    this.widths = this.width - (200 * 4)
    if (viewportWidth < 440) {
      self.swiperOption = {  // 设置slides可视数量
        slidesPerView: 1,
        // 设置滑块之间的距离
        spaceBetween: 15,
        // 其他你可能需要的配置
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
    setTimeout(this.handleAnimate, 1000);
  },
  methods: {
    init() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id: 1,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factorys = res;
          //console.log(self.Images);
        });
    },   
    inits() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id: 2,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factoryss = res;
          // console.log(self.Images);
        });
    },   
    initss() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id: 3,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factorysss = res;
          // console.log(self.Images);
        });
    },  
    initsss() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id: 4,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factoryssss = res;
          // console.log(self.Images);
        });
    },  
    initssss() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id: 5,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factorysssss = res;
          // console.log(self.Images);
        });
    },
    initsssss() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id:5,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factoryssssss = res;
          // console.log(self.Images);
        });
    },
    initssssss() {
      let self = this;
      // console.log(self);
      this.$api.mall
        .getAboutdetail({
          id:6,
        })
        .then((ress) => {
          let res = ress.data.data;
          //console.log(res, "Ssbbb");
          self.Factorysssssss = res;
          // console.log(self.Images);
        });
    },
    start() {
      this.$refs.example1.start()
      this.$refs.example2.start()
      this.$refs.example3.start()
      this.$refs.example4.start()
    },
    starts() {
      this.$refs.example5.start()
      this.$refs.example6.start()
      this.$refs.example7.start()
      this.$refs.example8.start()
    },
      // 获取商品信息
    getProductList() {
      let id = '14';
      this.currentPage = 1
      this.$api.mall.getCertificate({  limit: 12, page: 1 }).then((res) => {
        this.slideList = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    changeNew(val) {
      let self = this
      
      let viewportWidth = document.documentElement.clientWidth;
      document.documentElement.scrollTop = "0px";
      /**
      if (viewportWidth < 440) {
        if(val=='5'){
          this.$router.push(`/certificates`);
        }
      }**/
      self.newType = val
      self.id = val


      this.left = (parseInt(viewportWidth) - 1600) / 2
      this.width = viewportWidth - this.left
      this.widths = this.width - (200 * 4)

      if (viewportWidth < 440) {
        this.left = 0
        this.width = viewportWidth
        this.widths = viewportWidth
      }
      setTimeout(this.handleAnimate, 1000);
      //self.getProductList()
    },
    Messageadds() {
      let self = this;
      if (!self.form.name) {
        self.$layer.msg('Please Name');
        return
      }
      if (!self.form.email) {
        self.$layer.msg('Please email');
        return
      }
      if (!self.form.description) {
        self.$layer.msg('Please Message');
        return
      }
      this.$api.mall.Messageadd({
        name: self.form.name,
        description: self.form.description,
        email: self.form.email,
      })
        .then((res) => {
          if (res.code == 1) {
            self.$message.success("success");
            self.reset();
          } else {
            self.$message.error(res.msg);
          }
        });
    },
    reset() {
      let self = this;
      self.form.name = ''
      self.form.description = ''
      self.form.email = ''
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    buy(val) {
      //let id = this.$route.params.id;
      //this.$router.push(`/detail/${val}`);
    },
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 0px) and (max-width:1024px) {
  .abouts {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .web_content {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        .about-pros{
          width: 90%;
          overflow: hidden;
          line-height: 28px !important;
          box-sizing: border-box;
          margin: 0px auto;
          padding-top: 25px;
          padding-bottom: 25px;
          }

        .cer-abouts {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 25px 0px 0px 0px;

          .slide-mores:hover {
            background: #02999d;
            border: 1px solid #02999d;
            color: #fff;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin: 25px auto auto auto;
            background: none;
            color: #252525;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #252525;
            width: 110px;
            line-height: 36px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .cer-title {
            width: 90%;
            font-size: 32px;
            font-weight: 600;
            color: #252525;
            text-align: center;
            overflow: hidden;
            margin: auto auto 25px auto;
            padding: 0px;

          }
          .swiper-centers {
            width: 90%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;
          }
        }
        .service-abouts{
          width: 90%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 25px 0px 0px 0px;

          .service-s {
            width: 100%;
            overflow: hidden;
            margin: auto auto 25px auto;

            .text {
              width: 100%;
              overflow: hidden;
              position: absolute;
              top: 20px;
              left: 20px;

              .title {
                color: #fff;
                font-size: 32px;
                font-weight: 600;
              }
            }

            .slide-mores:hover {
              background: #fff;
              border: 1px solid #fff;
              color: #02999d;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 20px;
              margin-left: 10px;
              background: none;
              color: #02999d;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #02999d;
              width: 110px;
              line-height: 36px;

              .slide-more {
                transform: skewX(20deg);
              }
            }
            .ri {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
            .le {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
          }

        }

        .service-about {
          width: 90%;
          overflow: hidden;
          display: none;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 50px 0px 0px 0px;

          .service-s {
            width: 100%;
            overflow: hidden;
            margin: auto auto 50px auto;

            .text {
              width: 100%;
              overflow: hidden;
              position: absolute;
              top: 80px;
              left: 80px;

              .title {
                color: #fff;
                font-size: 35px;
                font-weight: 600;
              }
            }

            .slide-mores:hover {
              background: #fff;
              border: 1px solid #fff;
              color: #02999d;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 20px;
              margin-left: 10px;
              background: none;
              color: #02999d;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #02999d;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }
            .ri {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
            .le {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
          }
        }
        .product-css {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 0px 0px 0px 0px;

          .product-is {
            width: 100%;
            overflow: hidden;
            margin: auto auto 25px auto;
            padding: 0px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin: 25px auto auto auto;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 110px;
              line-height: 36px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ts {
              width: 90%;
              overflow: hidden;
              flex-wrap: wrap;
              display: flex;
              justify-content: space-between;
              margin: 25px auto auto auto;
              box-sizing: border-box;
              background: #fff;
              padding: 0px 0px 0px 0px;

              .items {
                width: 49%;
                margin-left: 1%;
                overflow: hidden;
                position: relative;
                padding: 0px;
                box-sizing: border-box;

                .p-t {
                  width: 100%;
                  overflow: hidden;
                  position: absolute;
                  font-size: 25px;
                  top: 45px;
                  left: 0px;
                  text-align: center;
                  color: #fff;
                }
              }
            }

            .t1 {
              font-size: 32px;
              text-align: center;
              font-weight: 600;
            }
          }
        }
        .product-cs {
          width: 100%;
          overflow: hidden;
          display: none;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 50px 0px 0px 0px;

          .product-is {
            width: 100%;
            overflow: hidden;
            margin: auto auto 50px auto;
            padding: 0px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin: 50px auto auto auto;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 128px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ts {
              width: 90%;
              overflow: hidden;
              flex-wrap: wrap;
              display: flex;
              justify-content: space-between;
              margin: 40px auto auto auto;
              box-sizing: border-box;
              background: #fff;
              padding: 0px 0px 0px 0px;

              .items {
                width: 49%;
                margin-left: 1%;
                overflow: hidden;
                position: relative;
                padding: 0px;
                box-sizing: border-box;

                .p-t {
                  width: 100%;
                  overflow: hidden;
                  position: absolute;
                  font-size: 25px;
                  top: 45px;
                  left: 0px;
                  text-align: center;
                  color: #fff;
                }
              }
            }

            .t1 {
              font-size: 32px;
              text-align: center;
              font-weight: 600;
            }
          }
        }
        .mobile-cs{
          width:100%;
          overflow: hidden;
          margin: 0px auto;
          box-sizing: border-box;
          background: #fff;
        }

        .mobile-p-t {
          width: 90%;
          overflow: hidden;
          margin: 25px auto;
          box-sizing: border-box;
          padding: 0px;
          position: relative;
          background: url('~@/assets/img/sytj-1.png') no-repeat right #252525;
          background-position: right bottom;
          background-size: 180px auto;

          .p-o {
            width: 100%;
            height: calc(100% - 50px);
            display: flex;
            align-items: center;
            justify-content: center;

            .p-s {
              position: relative;
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              z-index: 99;
              box-sizing: border-box;
              padding-left: 25px;

              .slide-mores:hover {
                background: #fff;
                border: 1px solid #fff;
                color: #02999d;
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
              }

              .slide-mores {
                cursor: pointer;
                margin-top: 25px;
                margin-left: 10px;
                margin-bottom: 68px;
                background: none;
                color: #02999d;
                text-align: center;
                transform: skewX(-20deg);
                border: 1px solid #02999d;
                width: 88px;
                font-size: 14px;
                line-height: 30px;

                .slide-more {
                  transform: skewX(20deg);
                }
              }

              .p-titles {
                padding-top: 50px;
                width: 100%;
                overflow: hidden;
                text-align: left;
                color: #00969a;
                font-size: 15px;
              }

              .p-text {
                font-size: 30px;
                font-weight: 600;
                line-height: 40px;
                color: #fff;
              }
            }
          }
        }

        .about-ps {
          display: none;
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 0px 0px 0px 0px;

          .slide-mores:hover {
            background: #fff;
            border: 1px solid #fff;
            color: #02999d;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin-top: 50px;
            margin-left: 10px;
            background: none;
            color: #02999d;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #02999d;
            width: 88px;
            font-size: 14px;
            line-height: 30px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .about-f {
            width: 100%;
            position: relative;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;

            .about_text {
              top: 0px;
              left: 0px;
              width: 100%;
              overflow: hidden;
              position: absolute;
              box-sizing: border-box;

              .t2 {
                margin-top: 0px;
                color: #fff;
                font-weight: 600;
                line-height: 48px;
                font-size: 25px;
              }

              .t1 {
                font-size: 15px;
                color: #00959b;
              }

            }
          }
        }

        .about-is {
          width: 100%;
          margin: 0px auto auto auto;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px 0px 0px 0px;
          background: #fff;
          position: relative;

          .about-products {
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin: 25px auto auto auto;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 110px;
              line-height: 36px;

              .slide-more {
                transform: skewX(20deg);
              }
            }


            .font-centers {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              padding: 0px;
              box-sizing: border-box;
                    
        
            }

            .f-2 {
              width: 100%;
              overflow: hidden;
              margin: 0px;
              padding-left: 30px;
              position: relative;
              box-sizing: border-box;
              line-height: 25px;
              color: #676767;

              .f-p {
                position: absolute;
                left: 0px;
                top: 3.5px;
                margin-left: 5px;
                text-align: center;
                transform: skewX(-20deg);
                background: #00959b;
                width: 15px;
                height: 15px;
              }
            }

            .t-1 {
              font-size: 32px;
              font-weight: 600;
              color: #1c1c1c;
            }

            .f-1 {
              width: 100%;
              overflow: hidden;
              margin-top:25px;
              margin-bottom:25px;
              color: #00959b;
            }
          }

          .about-pro {
            width: 90%;
            overflow: hidden;
            margin: 0px auto;
            padding: 50px 0px 0px 0px;
            box-sizing: border-box;
          }

          .le {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
          }
        }

        .about-i {
          width: 100%;
          flex-wrap: wrap;
          display: none;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px 0px 0px 0px;
          position: relative;

          .about-products {
            width: 50%;
            overflow: hidden;
            position: absolute;
            bottom: 0px;
            right: 0px;
            background: #fff;
            min-height: 500px;
            padding-top: 90px;
            padding-left: 80px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }


            .font-centers {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              padding: 0px;
              box-sizing: border-box;
            }

            .f-2 {
              width: 70%;
              overflow: hidden;
              margin: 0px;
              padding: 0px;
              position: relative;
              box-sizing: border-box;
              font-size: 15px;
              line-height: 22px;
              padding-left: 38px;
              color: #676767;

              .f-p {
                position: absolute;
                left: 0px;
                top: 3.5px;
                margin-left: 5px;
                text-align: center;
                transform: skewX(-20deg);
                background: #00959b;
                width: 15px;
                height: 15px;
              }
            }

            .t-1 {
              margin-top: 25px;
              line-height: 22px;
              font-size: 35px;
              font-weight: 600;
              color: #1c1c1c;
            }

            .f-1 {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              color: #00959b;
              font-size: 18px;
            }
          }

          .about-pro {
            width: 90%;
            overflow: hidden;
            margin: 0px auto;
            padding: 50px 0px 0px 0px;
            box-sizing: border-box;
          }

          .le {
            width: 50%;
            float: left;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
          }
        }

        .about-companys {
          width: 100%;
          flex-wrap: wrap;
          justify-content: space-between;
          background: #fff;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 50px 0px 0px 0px;

          .about-s {
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0px auto;
            box-sizing: border-box;

            .itemss {
              background: url(../assets/img/bjtb-01.png) no-repeat center #252525;
              background-size: 100%;
              overflow: hidden;
              position: relative;
              min-height: 388px;

              .items-box {
                width: 100%;
                padding: 25px;
                overflow: hidden;
                margin: 0px auto;
                box-sizing: border-box;

                .slide-mores:hover {
                  background: #fff;
                  border: 1px solid #fff;
                  color: #02999d;
                  -webkit-transition: 0.6s ease-in-out;
                  transition: 0.6s ease-in-out;
                }

                .slide-mores {
                  cursor: pointer;
                  margin-top: 25px;
                  margin-left: 10px;
                  background: none;
                  color: #02999d;
                  text-align: center;
                  transform: skewX(-20deg);
                  border: 1px solid #02999d;
                  width: 110px;
                  line-height: 36px;

                  .slide-more {
                    transform: skewX(20deg);
                  }
                }


                .font {
                  width: 100%;
                  overflow: hidden;
                  margin-top: 25px;
                  color: #767676;
                  line-height: 28px;
                }

                .text {
                  width: 100%;
                  overflow: hidden;
                  font-size: 32px;
                  margin: 25px auto auto auto;
                  padding: 0px;
                  color: #fff;
                  font-weight: 600;
                  box-sizing: border-box;
                }

                .title {
                  width: 100%;
                  overflow: hidden;
                  margin: 0px auto;
                  padding: 0px;
                  color: #00959b;
                }
              }
            }

            .items {
              width: 24%;
              position: relative;
              overflow: hidden;
              padding: 0px;
              margin-right: 1%;
              float: left;

              .p-ss {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                top: 30px;
                color: #fff;
              }

              .p-s {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                bottom: 30px;
                color: #fff;
              }
            }
          }

        }

        .about-company {
          width: 100%;
          display: none;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 50px 0px 0px 0px;

          .about-s {
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0px auto;
            box-sizing: border-box;

            .itemss {
              background: url(../assets/img/bjtb-01.png) no-repeat center #252525;
              background-size: 100%;
              overflow: hidden;
              position: relative;
              min-height: 388px;

              .items-box {
                width: 100%;
                padding: 80px 80px 80px 150px;
                overflow: hidden;
                margin: 0px auto;
                box-sizing: border-box;

                .slide-mores:hover {
                  background: #fff;
                  border: 1px solid #fff;
                  color: #02999d;
                  -webkit-transition: 0.6s ease-in-out;
                  transition: 0.6s ease-in-out;
                }

                .slide-mores {
                  cursor: pointer;
                  margin-top: 50px;
                  margin-left: 10px;
                  background: none;
                  color: #02999d;
                  text-align: center;
                  transform: skewX(-20deg);
                  border: 1px solid #02999d;
                  width: 88px;
                  font-size: 14px;
                  line-height: 30px;

                  .slide-more {
                    transform: skewX(20deg);
                  }
                }


                .font {
                  width: 100%;
                  overflow: hidden;
                  margin-top: 45px;
                  font-size: 18px;
                  color: #767676;
                  line-height: 28px;
                }

                .text {
                  width: 100%;
                  overflow: hidden;
                  font-size: 48px;
                  margin: 20px auto auto auto;
                  padding: 0px;
                  line-height: 48px;
                  color: #fff;
                  font-weight: 600;
                  box-sizing: border-box;
                }

                .title {
                  width: 100%;
                  overflow: hidden;
                  margin: 0px auto;
                  padding: 0px;
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .items {
              width: 180px;
              position: relative;
              overflow: hidden;
              padding: 0px;
              margin-right: 20px;

              .p-ss {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                top: 80px;
                color: #fff;
              }

              .p-s {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                bottom: 80px;
                color: #fff;
              }
            }
          }
        }

        .about-items {
          width: 100%;
          background: #fff;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 25px 0px 0px 0px;

          .about-title {
            width: 100%;
            color: #3ca2a7;
            margin: auto auto 25px auto;
            padding: 0px;
            box-sizing: border-box;
            overflow: hidden;
          }

          .right {
            width: 90%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;
          }

          .lefts {
            width: 90%;
            overflow: hidden;
            padding: 0px;
            box-sizing: border-box;
            margin: 25px auto auto auto;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 25px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 110px;
              line-height: 36px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .text {
              width: 100%;
              overflow: hidden;
              margin-top: 25px;
              font-weight: 400;
              line-height: 25px;
              color: #606060;
            }

            .fonts {
              font-family:'Rany-Bold';
              font-size: 32px;
              font-weight: 600;
              color: #252525;
            }
          }

          .left {
            width: 50%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;
            display: none;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .text {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              font-weight: 400;
              line-height: 25px;
              font-size: 15px;
              color: #606060;
            }

            .fonts {
              font-size: 35px;
              font-weight: 600;
              color: #252525;
            }
          }
        }
      }

      .products-nav-centers {
        display: none;
      }
      .products-nav-centerss{
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 100%;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        text-transform: uppercase;
        overflow: hidden;
        margin: 30px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }


      .link-list {
        width: 90%;
        margin: 0px auto;
        overflow: hidden;
        margin-top: 50px;
        margin-bottom: 80px;
        box-sizing: border-box;
        padding: 0px;

        .link-items {
          width: 31.33%;
          overflow: hidden;
          margin-left: 3%;
          float: left;
          box-sizing: border-box;
          min-height: 197px;
          font-size: 18px;
          font-weight: 600;
          padding-top: 50px;
          position: relative;
          padding-right: 110px;
          color: #1c1c1c;
          padding-left: 90px;
          padding-bottom: 60px;
          background: #ededed;
          cursor: pointer;

          .link-tel {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/WhatApp.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-phone {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/phone.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-address {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/address.png) no-repeat center #02999d;
            background-size: 36px;

          }
        }
      }

      .pageContent {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        background: #ededed;
        box-sizing: border-box;
        padding: 0px;


        .ri {
          width: calc(50% - 90px);
          padding-left: 90px;
          overflow: hidden;
          margin: 0px auto;

          .btn_send {
            color: #02999d;
            width: 128px;
            cursor: pointer;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: none;
            border: 2px solid #02999d;

            .send_icon_text {
              width: 48px;
              line-height: 48px;
              margin: 0px auto;
              display: block;
              background: url(../assets/img/send.png) no-repeat right;
              background-size: 28px 28px;
              padding-right: 28px;
              text-align: center;
            }
          }

          .text {
            width: 100%;
            overflow: hidden;
            color: #676767;
            font-size: 15px;
            margin-top: 15px;
            margin-bottom: 35px;
          }

          .title {
            padding-top: 80px;
            font-size: 35px;
            color: #252525;
            font-weight: 600;
            width: 440px;
            overflow: hidden;
            line-height: 48px;
          }

        }

        .le {
          width: 50%;
          float: left;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          background: url(../assets/img/123.png) no-repeat center;
          background-size: 100%;

          .p-s {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 50px;
            padding-left: 80px;
            box-sizing: border-box;

            .call-us {
              width: 80%;

              overflow: hidden;
              padding-top: 50px;
              padding-bottom: 60px;
              border-top: 1px solid #676767;
              border-bottom: 1px solid #676767;
            }
          }

          .p-2-t {
            padding-left: 80px;
            padding-top: 30px;
            overflow: hidden;
            width: 100%;
            color: #676767;
          }

          .p-t {
            padding-left: 80px;
            padding-top: 80px;
            width: 100%;
            overflow: hidden;
            color: #fff;
            font-size: 35px;
            font-weight: 600;
          }
        }

      }

      .titles {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        text-align: center;
        font-size: 35px;
        padding-top: 80px;
        padding-bottom: 80px;
        color: #1c1c1c;
        font-weight: 600;
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
      img{
        width: 150%;
        height:auto
      }

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;
        img{
          width: 150%;
          height: auto;
        }

        .p-title {
          width: 100%;
          margin: 0px auto;  
          text-transform: uppercase;

          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 0px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 61px;

    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .abouts {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;

    .mobile-p-t {
      display: none;
    }

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;


      .web_content {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        .about-pros{
          width: 1600px;
          overflow: hidden;
          box-sizing: border-box;
          line-height: 30px;
          margin: 0px auto;
          padding: 50px 0px 50px 0px;
          }

        .cer-abouts {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .slide-mores:hover {
            background: #02999d;
            border: 1px solid #02999d;
            color: #fff;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin: 50px auto auto auto;
            background: none;
            color: #252525;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #252525;
            width:160px;
            line-height: 30px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .cer-title {
            width: 1200px;
            font-size: 35px;
            font-weight: 600;
            color: #252525;
            text-align: center;
            overflow: hidden;
            margin: auto auto 50px auto;
            padding: 0px;

          }

          .swiper-centers {
            width: 1200px;
            overflow: hidden;
            margin: 0px auto;
            //min-height: 500px;
            padding: 0px;
            box-sizing: border-box;
          }
        }
        .service-abouts{
          display: none;
        }

        .service-about {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .service-s {
            width: 1200px;
            overflow: hidden;
            margin: auto auto 80px auto;
            display: flex;

            .text {
              width: 100%;
              overflow: hidden;
              position: absolute;
              top: 80px;
              left: 80px;

              .title {
                color: #fff;
                font-size: 35px;
                font-weight: 600;
              }
            }

            .slide-mores:hover {
              background: #fff;
              border: 1px solid #fff;
              color: #02999d;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 20px;
              margin-left: 10px;
              background: none;
              color: #02999d;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #02999d;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ri {
              width: 50%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }

            .le {
              width: 50%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
          }
        }
        .product-css{
          display: none
        }

        .product-cs {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 80px 0px 0px 0px;

          .product-is {
            width: 1200px;
            overflow: hidden;
            margin: auto auto 90px auto;
            padding: 0px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin: 50px auto auto auto;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ts {
              width: 100%;
              overflow: hidden;
              flex-wrap: wrap;
              display: flex;
              justify-content: space-between;
              margin: 40px auto auto auto;
              box-sizing: border-box;
              background: #fff;
              padding: 0px 0px 0px 0px;

              .items {
                width: 23.875%;
                margin-left: 1.5%;
                overflow: hidden;
                position: relative;
                padding: 0px;
                box-sizing: border-box;

                .p-t {
                  width: 100%;
                  overflow: hidden;
                  position: absolute;
                  font-size: 30px;
                  top: 45px;
                  left: 0px;
                  text-align: center;
                  color: #fff;
                }
              }
            }

            .t1 {
              font-size: 35px;
              text-align: center;
              font-weight: 600;
            }
          }
        }

        .about-ps {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 0px 0px 0px 0px;

          .slide-mores:hover {
            background: #fff;
            border: 1px solid #fff;
            color: #02999d;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin-top: 50px;
            margin-left: 10px;
            background: none;
            color: #02999d;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #02999d;
            width: 160px;
            line-height: 30px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .about-f {
            width: 1200px;
            position: relative;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;

            .about_text {
              top: 0px;
              left: 0px;
              width: 100%;
              overflow: hidden;
              position: absolute;
              box-sizing: border-box;
              padding-left: 125px;
              padding-top: 125px;

              .t2 {
                margin-top: 20px;
                color: #fff;
                font-weight: 600;
                line-height: 48px;
                font-size: 48px;
              }

              .t1 {
                font-size: 18px;
                color: #00959b;
              }

            }
          }
        }
        .about-is{
          display: none;
        }

        .about-i {
          width: 100%;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px 0px 0px 0px;
          position: relative;

          .about-products {
            width: 50%;
            overflow: hidden;
            position: absolute;
            bottom: 0px;
            right: 0px;
            background: #fff;
            min-height: 500px;
            padding-top: 80px;
            padding-left: 80px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }


            .font-centers {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              padding: 0px;
              box-sizing: border-box;
            }

            .f-2 {
              width: 85%;
              overflow: hidden;
              margin: 0px;
              padding: 0px;
              position: relative;
              box-sizing: border-box;
              font-size: 18px;
              line-height: 22px;
              padding-left: 38px;
              color: #676767;

              .f-p {
                position: absolute;
                left: 0px;
                top: 3.5px;
                margin-left: 5px;
                text-align: center;
                transform: skewX(-20deg);
                background: #00959b;
                width: 15px;
                height: 15px;
              }
            }

            .t-1 {
              //margin-top: 25px;
            //  line-height: 22px;
              font-size: 48px;
              font-weight: 600;
              color: #1c1c1c;
            }

            .f-1 {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              color: #00959b;
              font-size: 18px;
            }
          }

          .about-pro {
            width: 1200px;
            overflow: hidden;
            margin: 0px auto;
            padding: 80px 0px 0px 0px;
            box-sizing: border-box;
          }

          .le {
            width: 880px;
            float: left;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
          }
        }

        .about-companys {
          display: none;
        }

        .about-company {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .about-s {
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0px auto;
            box-sizing: border-box;

            .itemss {
              background: url(../assets/img/bjtb-01.png) no-repeat center #252525;
              background-size: 100%;
              overflow: hidden;
              position: relative;
              min-height: 388px;

              .items-box {
                width: 100%;
                padding: 30px 40px 40px 30px;
                overflow: hidden;
                margin: 0px auto;
                box-sizing: border-box;

                .slide-mores:hover {
                  background: #fff;
                  border: 1px solid #fff;
                  color: #02999d;
                  -webkit-transition: 0.6s ease-in-out;
                  transition: 0.6s ease-in-out;
                }

                .slide-mores {
                  cursor: pointer;
                  margin-top: 50px;
                  margin-left: 10px;
                  background: none;
                  color: #02999d;
                  text-align: center;
                  transform: skewX(-20deg);
                  border: 1px solid #02999d;
                  width: 160px;
                  line-height: 30px;

                  .slide-more {
                    transform: skewX(20deg);
                  }
                }


                .font {
                  width: 100%;
                  overflow: hidden;
                  margin-top: 45px;
                  font-size: 18px;
                  color: #767676;
                  line-height: 28px;
                }

                .text {
                  width: 100%;
                  overflow: hidden;
                  font-size: 40px;
                  margin: 20px auto auto auto;
                  padding: 0px;
                  line-height: 48px;
                  color: #fff;
                  font-weight: 600;
                  box-sizing: border-box;
                }

                .title {
                  width: 100%;
                  overflow: hidden;
                  margin: 0px auto;
                  padding: 0px;
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .items {
              width: 180px;
              position: relative;
              overflow: hidden;
              padding: 0px;
              margin-right: 20px;

              .p-ss {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                top: 80px;
                color: #fff;
              }

              .p-s {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                bottom: 80px;
                color: #fff;
              }
            }
          }
        }

        .about-items {
          width: 1200px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .about-title {
            width: 100%;
            color: #3ca2a7;
            margin: auto auto 30px auto;
            padding: 0px;
            box-sizing: border-box;
            overflow: hidden;
          }

          .right {
            width: 50%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;
          }

          .lefts {
            display: none;
          }

          .left {
            width: 50%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .text {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              font-weight: 400;
              line-height: 25px;
              font-size: 18px;
              color: #606060;
            }

            .fonts {
              font-size: 48px;
              font-weight: 600;
              color: #252525;
            }
          }
        }
      }
      .products-nav-centerss{
        display: none
      }

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 100%;
        font-size: 18px;
        color: #252525;
        text-transform: uppercase;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }


      .link-list {
        width: 1200px;
        margin: 0px auto;
        overflow: hidden;
        margin-top: 50px;
        margin-bottom: 80px;
        box-sizing: border-box;
        padding: 0px;

        .link-items {
          width: 31.33%;
          overflow: hidden;
          margin-left: 3%;
          float: left;
          box-sizing: border-box;
          min-height: 197px;
          font-size: 18px;
          font-weight: 600;
          padding-top: 50px;
          position: relative;
          padding-right: 110px;
          color: #1c1c1c;
          padding-left: 90px;
          padding-bottom: 60px;
          background: #ededed;
          cursor: pointer;

          .link-tel {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/WhatApp.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-phone {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/phone.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-address {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/address.png) no-repeat center #02999d;
            background-size: 36px;

          }
        }
      }

      .pageContent {
        width: 1200px;
        overflow: hidden;
        margin: 0px auto;
        background: #ededed;
        box-sizing: border-box;
        padding: 0px;


        .ri {
          width: calc(50% - 90px);
          padding-left: 90px;
          overflow: hidden;
          margin: 0px auto;

          .btn_send {
            color: #02999d;
            width: 128px;
            cursor: pointer;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: none;
            border: 2px solid #02999d;

            .send_icon_text {
              width: 48px;
              line-height: 48px;
              margin: 0px auto;
              display: block;
              background: url(../assets/img/send.png) no-repeat right;
              background-size: 28px 28px;
              padding-right: 28px;
              text-align: center;
            }
          }

          .text {
            width: 100%;
            overflow: hidden;
            color: #676767;
            font-size: 15px;
            margin-top: 15px;
            margin-bottom: 35px;
          }

          .title {
            padding-top: 80px;
            font-size: 35px;
            color: #252525;
            font-weight: 600;
            width: 440px;
            overflow: hidden;
            line-height: 48px;
          }

        }

        .le {
          width: 50%;
          float: left;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          background: url(../assets/img/123.png) no-repeat center;
          background-size: 100%;

          .p-s {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 50px;
            padding-left: 80px;
            box-sizing: border-box;

            .call-us {
              width: 80%;
              overflow: hidden;
              padding-top: 50px;
              padding-bottom: 60px;
              border-top: 1px solid #676767;
              border-bottom: 1px solid #676767;
            }
          }

          .p-2-t {
            padding-left: 80px;
            padding-top: 30px;
            overflow: hidden;
            width: 100%;
            color: #676767;
          }

          .p-t {
            padding-left: 80px;
            padding-top: 80px;
            width: 100%;
            overflow: hidden;
            color: #fff;
            font-size: 35px;
            font-weight: 600;
          }
        }

      }

      .titles {
        width: 1200px;
        overflow: hidden;
        margin: 0px auto;
        text-align: center;
        font-size: 35px;
        padding-top: 80px;
        padding-bottom: 80px;
        color: #1c1c1c;
        font-weight: 600;
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;  
          text-transform: uppercase;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }

}


@media screen and (min-width: 1601px) and (max-width:8000px) {
  .abouts {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;

    .mobile-p-t {
      display: none;
    }

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;


      .web_content {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        .about-pros{
          width: 1600px;
          overflow: hidden;
          box-sizing: border-box;
          line-height: 30px;
          margin: 0px auto;
          padding: 50px 0px 50px 0px;
          }

        .cer-abouts {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .slide-mores:hover {
            background: #02999d;
            border: 1px solid #02999d;
            color: #fff;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin: 50px auto auto auto;
            background: none;
            color: #252525;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #252525;
            width:160px;
            line-height: 30px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .cer-title {
            width: 1600px;
            font-size: 35px;
            font-weight: 600;
            color: #252525;
            text-align: center;
            overflow: hidden;
            margin: auto auto 50px auto;
            padding: 0px;

          }

          .swiper-centers {
            width: 1600px;
            overflow: hidden;
            margin: 0px auto;
            //min-height: 500px;
            padding: 0px;
            box-sizing: border-box;
          }
        }
        .service-abouts{
          display: none;
        }

        .service-about {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .service-s {
            width: 1600px;
            overflow: hidden;
            margin: auto auto 80px auto;
            display: flex;

            .text {
              width: 100%;
              overflow: hidden;
              position: absolute;
              top: 80px;
              left: 80px;

              .title {
                color: #fff;
                font-size: 35px;
                font-weight: 600;
              }
            }

            .slide-mores:hover {
              background: #fff;
              border: 1px solid #fff;
              color: #02999d;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 20px;
              margin-left: 10px;
              background: none;
              color: #02999d;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #02999d;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ri {
              width: 50%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }

            .le {
              width: 50%;
              overflow: hidden;
              margin: 0px auto;
              position: relative;
            }
          }
        }
        .product-css{
          display: none
        }

        .product-cs {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 80px 0px 0px 0px;

          .product-is {
            width: 1600px;
            overflow: hidden;
            margin: auto auto 90px auto;
            padding: 0px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin: 50px auto auto auto;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .ts {
              width: 100%;
              overflow: hidden;
              flex-wrap: wrap;
              display: flex;
              justify-content: space-between;
              margin: 40px auto auto auto;
              box-sizing: border-box;
              background: #fff;
              padding: 0px 0px 0px 0px;

              .items {
                width: 23.875%;
                margin-left: 1.5%;
                overflow: hidden;
                position: relative;
                padding: 0px;
                box-sizing: border-box;

                .p-t {
                  width: 100%;
                  overflow: hidden;
                  position: absolute;
                  font-size: 30px;
                  top: 45px;
                  left: 0px;
                  text-align: center;
                  color: #fff;
                }
              }
            }

            .t1 {
              font-size: 35px;
              text-align: center;
              font-weight: 600;
            }
          }
        }

        .about-ps {
          width: 100%;
          overflow: hidden;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          background: #fff;
          padding: 0px 0px 0px 0px;

          .slide-mores:hover {
            background: #fff;
            border: 1px solid #fff;
            color: #02999d;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
          }

          .slide-mores {
            cursor: pointer;
            margin-top: 50px;
            margin-left: 10px;
            background: none;
            color: #02999d;
            text-align: center;
            transform: skewX(-20deg);
            border: 1px solid #02999d;
            width: 160px;
            line-height: 30px;

            .slide-more {
              transform: skewX(20deg);
            }
          }

          .about-f {
            width: 1600px;
            position: relative;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;

            .about_text {
              top: 0px;
              left: 0px;
              width: 100%;
              overflow: hidden;
              position: absolute;
              box-sizing: border-box;
              padding-left: 125px;
              padding-top: 125px;

              .t2 {
                margin-top: 20px;
                color: #fff;
                font-weight: 600;
                line-height: 48px;
                font-size: 48px;
              }

              .t1 {
                font-size: 18px;
                color: #00959b;
              }

            }
          }
        }
        .about-is{
          display: none;
        }

        .about-i {
          width: 100%;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px 0px 0px 0px;
          position: relative;

          .about-products {
            width: 50%;
            overflow: hidden;
            position: absolute;
            bottom: 0px;
            right: 0px;
            background: #fff;
            min-height: 500px;
            padding-top: 80px;
            padding-left: 80px;
            box-sizing: border-box;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }


            .font-centers {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              padding: 0px;
              box-sizing: border-box;
            }

            .f-2 {
              width: 85%;
              overflow: hidden;
              margin: 0px;
              padding: 0px;
              position: relative;
              box-sizing: border-box;
              font-size: 18px;
              line-height: 22px;
              padding-left: 38px;
              color: #676767;

              .f-p {
                position: absolute;
                left: 0px;
                top: 3.5px;
                margin-left: 5px;
                text-align: center;
                transform: skewX(-20deg);
                background: #00959b;
                width: 15px;
                height: 15px;
              }
            }

            .t-1 {
              //margin-top: 25px;
            //  line-height: 22px;
              font-size: 48px;
              font-weight: 600;
              color: #1c1c1c;
            }

            .f-1 {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              color: #00959b;
              font-size: 18px;
            }
          }

          .about-pro {
            width: 1600px;
            overflow: hidden;
            margin: 0px auto;
            padding: 80px 0px 0px 0px;
            box-sizing: border-box;
          }

          .le {
            width: 880px;
            float: left;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
          }
        }

        .about-companys {
          display: none;
        }

        .about-company {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .about-s {
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0px auto;
            box-sizing: border-box;

            .itemss {
              background: url(../assets/img/bjtb-01.png) no-repeat center #252525;
              background-size: 100%;
              overflow: hidden;
              position: relative;
              min-height: 388px;

              .items-box {
                width: 100%;
                padding: 80px 80px 80px 150px;
                overflow: hidden;
                margin: 0px auto;
                box-sizing: border-box;

                .slide-mores:hover {
                  background: #fff;
                  border: 1px solid #fff;
                  color: #02999d;
                  -webkit-transition: 0.6s ease-in-out;
                  transition: 0.6s ease-in-out;
                }

                .slide-mores {
                  cursor: pointer;
                  margin-top: 50px;
                  margin-left: 10px;
                  background: none;
                  color: #02999d;
                  text-align: center;
                  transform: skewX(-20deg);
                  border: 1px solid #02999d;
                  width: 160px;
                  line-height: 30px;

                  .slide-more {
                    transform: skewX(20deg);
                  }
                }


                .font {
                  width: 100%;
                  overflow: hidden;
                  margin-top: 45px;
                  font-size: 18px;
                  color: #767676;
                  line-height: 28px;
                }

                .text {
                  width: 100%;
                  overflow: hidden;
                  font-size: 40px;
                  margin: 20px auto auto auto;
                  padding: 0px;
                  line-height: 48px;
                  color: #fff;
                  font-weight: 600;
                  box-sizing: border-box;
                }

                .title {
                  width: 100%;
                  overflow: hidden;
                  margin: 0px auto;
                  padding: 0px;
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .items {
              width: 180px;
              position: relative;
              overflow: hidden;
              padding: 0px;
              margin-right: 20px;

              .p-ss {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                top: 80px;
                color: #fff;
              }

              .p-s {
                width: 100%;
                text-align: center;
                overflow: hidden;
                position: absolute;
                left: 0px;
                bottom: 80px;
                color: #fff;
              }
            }
          }
        }

        .about-items {
          width: 1600px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 80px 0px 0px 0px;

          .about-title {
            width: 100%;
            color: #3ca2a7;
            margin: auto auto 30px auto;
            padding: 0px;
            box-sizing: border-box;
            overflow: hidden;
          }

          .right {
            width: 50%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;
          }

          .lefts {
            display: none;
          }

          .left {
            width: 50%;
            overflow: hidden;
            padding: 0px;
            margin: 0px auto;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 10px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 160px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .text {
              width: 100%;
              overflow: hidden;
              margin-top: 40px;
              font-weight: 400;
              line-height: 25px;
              font-size: 18px;
              color: #606060;
            }

            .fonts {
              font-size: 48px;
              font-weight: 600;
              color: #252525;
            }
          }
        }
      }
      .products-nav-centerss{
        display: none
      }

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 100%;
        font-size: 18px;
        color: #252525;
        text-transform: uppercase;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }


      .link-list {
        width: 1600px;
        margin: 0px auto;
        overflow: hidden;
        margin-top: 50px;
        margin-bottom: 80px;
        box-sizing: border-box;
        padding: 0px;

        .link-items {
          width: 31.33%;
          overflow: hidden;
          margin-left: 3%;
          float: left;
          box-sizing: border-box;
          min-height: 197px;
          font-size: 18px;
          font-weight: 600;
          padding-top: 50px;
          position: relative;
          padding-right: 110px;
          color: #1c1c1c;
          padding-left: 90px;
          padding-bottom: 60px;
          background: #ededed;
          cursor: pointer;

          .link-tel {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/WhatApp.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-phone {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/phone.png) no-repeat center #02999d;
            background-size: 36px;
          }

          .link-address {
            position: absolute;
            width: 90px;
            height: 90px;
            top: 0px;
            right: 0px;
            background: url(../assets/img/address.png) no-repeat center #02999d;
            background-size: 36px;

          }
        }
      }

      .pageContent {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        background: #ededed;
        box-sizing: border-box;
        padding: 0px;


        .ri {
          width: calc(50% - 90px);
          padding-left: 90px;
          overflow: hidden;
          margin: 0px auto;

          .btn_send {
            color: #02999d;
            width: 128px;
            cursor: pointer;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: none;
            border: 2px solid #02999d;

            .send_icon_text {
              width: 48px;
              line-height: 48px;
              margin: 0px auto;
              display: block;
              background: url(../assets/img/send.png) no-repeat right;
              background-size: 28px 28px;
              padding-right: 28px;
              text-align: center;
            }
          }

          .text {
            width: 100%;
            overflow: hidden;
            color: #676767;
            font-size: 15px;
            margin-top: 15px;
            margin-bottom: 35px;
          }

          .title {
            padding-top: 80px;
            font-size: 35px;
            color: #252525;
            font-weight: 600;
            width: 440px;
            overflow: hidden;
            line-height: 48px;
          }

        }

        .le {
          width: 50%;
          float: left;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          background: url(../assets/img/123.png) no-repeat center;
          background-size: 100%;

          .p-s {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 50px;
            padding-left: 80px;
            box-sizing: border-box;

            .call-us {
              width: 80%;
              overflow: hidden;
              padding-top: 50px;
              padding-bottom: 60px;
              border-top: 1px solid #676767;
              border-bottom: 1px solid #676767;
            }
          }

          .p-2-t {
            padding-left: 80px;
            padding-top: 30px;
            overflow: hidden;
            width: 100%;
            color: #676767;
          }

          .p-t {
            padding-left: 80px;
            padding-top: 80px;
            width: 100%;
            overflow: hidden;
            color: #fff;
            font-size: 35px;
            font-weight: 600;
          }
        }

      }

      .titles {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        text-align: center;
        font-size: 35px;
        padding-top: 80px;
        padding-bottom: 80px;
        color: #1c1c1c;
        font-weight: 600;
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;  
          text-transform: uppercase;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }
}
</style>